import React from "react";
import { Formik, Form, Field } from "formik";
import { Row, Col } from "reactstrap";
import { Button } from "zina-dogi-react";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { service as vendorService } from "../redux";

const filterVal = (key, val) => {
    return vendorService
        .getVendors(1, {
            ...(val !== "" ? { [`${key}__icontains`]: val } : {})
        })
        .then(resp =>
            resp.list.map(val => {
                return {
                    value: val[key],
                    label: val[key]
                };
            })
        );
};

const VendorsFilter = ({ className, onSubmit = () => {}, ...props }) => {
    const comp_op = {
        className: ["vendor_filters", className].join(" ")
    };
    const header = (
        <nav className="navbar">
            <span className="navbar-brand h4">Vendor Management</span>
        </nav>
    );
    props.setheader(header);
    return (
        <div {...comp_op}>
            <div className="content">
                <Formik
                    initialValues={{
                        legal_name: null,
                        vendor_number: null,
                        cancelled: null
                    }} // esto1 no funciona para actializar los valores del formulario
                    enableReinitialize={true}
                    onSubmit={(values, cmp) => handleSubmit(onSubmit, values, cmp)}
                >
                    {props => {
                        const { values, setFieldValue } = props;
                        return (
                            <Form>
                                <Row>
                                    <Col sm="12" md="4">
                                        <div className="form-group">
                                            <label>Vendor Name</label>
                                            <Field
                                                name="legal_name"
                                                value={values.legal_name}
                                                component={AsyncSelect}
                                                isClearable
                                                cacheOptions
                                                defaultOptions
                                                loadOptions={val => filterVal("legal_name", val)}
                                                onChange={val => setFieldValue("legal_name", val, false)}
                                            />
                                        </div>
                                    </Col>
                                    <Col sm="12" md="4">
                                        <div className="form-group">
                                            <label>Vendor Code</label>
                                            <Field
                                                name="vendor_number"
                                                value={values.vendor_number}
                                                component={AsyncSelect}
                                                isClearable
                                                cacheOptions
                                                defaultOptions
                                                loadOptions={val => filterVal("vendor_number", val)}
                                                onChange={val => setFieldValue("vendor_number", val, false)}
                                            />
                                        </div>
                                    </Col>
                                    <Col sm="12" md="4">
                                        <div className="form-group">
                                            <label>Vendor Status</label>
                                            <Field
                                                component={Select}
                                                name="cancelled"
                                                value={values.cancelled}
                                                options={[
                                                    {
                                                        value: "True",
                                                        label: "Cancelled"
                                                    },
                                                    {
                                                        value: "False",
                                                        label: "Active"
                                                    }
                                                ]}
                                                onChange={val => setFieldValue("cancelled", val, false)}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="controls">
                                    <Button type="reset" color="danger" icon="sync-alt">
                                        Clear filters
                                    </Button>
                                    <Button type="submit" color="primary" icon="filter">
                                        Filter
                                    </Button>
                                </Row>
                            </Form>
                        );
                    }}
                </Formik>
            </div>
        </div>
    );
};

const handleSubmit = (submit, obj, { setSubmitting }) => {
    const computeValue = key => (obj[key] ? { [key]: obj[key].value } : {});
    submit({
        ...computeValue("legal_name"),
        ...computeValue("vendor_number"),
        ...computeValue("cancelled")
    });
    setSubmitting(false);
};

export default VendorsFilter;
